import React from 'react';
import PropTypes from 'prop-types';
import styles from './Auth.module.scss';

const AuthShell = ({ children, className = '', backdrop = null }) => (
  <div
    className={`${styles.shell} ${
      backdrop ? styles.hasBackdrop : ''
    } ${className}`.trim()}
  >
    {backdrop && (
      <div
        className={styles.backdrop}
        style={{
          '--backdrop-desktop': `url(${backdrop.desktop})`,
          '--backdrop-tablet': `url(${backdrop.tablet})`,
        }}
        aria-hidden="true"
      />
    )}
    <div className={styles.wrap}>
      <div className={styles.card}>{children}</div>
      <p className={styles.legalLine}>
        &copy; Clowdy Ltd. t/a Twine.{' '}
        <a href="/terms" title="Terms Of Service">
          Terms
        </a>{' '}
        -{' '}
        <a href="/privacy" title="Privacy Policy">
          Privacy
        </a>
      </p>
    </div>
  </div>
);

AuthShell.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  backdrop: PropTypes.shape({
    desktop: PropTypes.string.isRequired,
    tablet: PropTypes.string.isRequired,
  }),
};

export default AuthShell;
